import * as React from 'react';
import styled from 'styled-components';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import { ANALYTICS, BREAKPOINT, COLOR, FONT_WEIGHT, FONT_SIZE, LINE_HEIGHT } from '@latitude/core/utils/constants';
import { Heading1 } from '@latitude/heading';
import { Text } from '@latitude/text';
import Breadcrumb from '@latitude/breadcrumb';
import LSHAME_SECONDARY_BLUE from './images/lshape-secondary-blue.svg';

var SecondaryHero = function SecondaryHero(_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      breadcrumb = _ref.breadcrumb;
  return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
    location: ANALYTICS.LOCATION.HERO
  }, /*#__PURE__*/React.createElement(HeroContainer, null, breadcrumb && /*#__PURE__*/React.createElement(Breadcrumb, null), /*#__PURE__*/React.createElement(LFrameBackground, null), /*#__PURE__*/React.createElement(ContentArea, {
    className: breadcrumb && 'breadcrumb'
  }, /*#__PURE__*/React.createElement(ContentInner, null, /*#__PURE__*/React.createElement(Heading, {
    color: COLOR.BLACK
  }, heading), subHeading && /*#__PURE__*/React.createElement(SubHeading, null, subHeading)))));
};

var HeroContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "SecondaryHero__HeroContainer",
  componentId: "sc-6yoig1-0"
})(["background:", ";height:180px;display:flex;align-items:center;position:relative;overflow:hidden;flex-wrap:wrap;@media (min-width:", "){height:272px;}"], COLOR.BLUE_BABY, BREAKPOINT.MD);
var ContentArea = /*#__PURE__*/styled.div.withConfig({
  displayName: "SecondaryHero__ContentArea",
  componentId: "sc-6yoig1-1"
})(["margin:0 auto;padding:0;width:100%;position:relative;z-index:2;@media (min-width:", "){max-width:calc(", " - 30px);}@media (min-width:", "){max-width:calc(", " - 30px);}@media (min-width:", "){max-width:calc(1140px - 30px);}&.breadcrumb{align-self:baseline;}"], BREAKPOINT.MD, BREAKPOINT.MD, BREAKPOINT.LG, BREAKPOINT.LG, BREAKPOINT.XL);
var ContentInner = /*#__PURE__*/styled.div.withConfig({
  displayName: "SecondaryHero__ContentInner",
  componentId: "sc-6yoig1-2"
})(["width:100%;padding:0 16px;@media (min-width:", "){width:66.6667%;padding:0;}"], BREAKPOINT.MD);
var Heading = /*#__PURE__*/styled(Heading1).withConfig({
  displayName: "SecondaryHero__Heading",
  componentId: "sc-6yoig1-3"
})(["font-size:32px;line-height:36px;margin-bottom:5px;@media (min-width:", "){font-size:48px;line-height:56px;}"], BREAKPOINT.MD);
var SubHeading = /*#__PURE__*/styled(Text).withConfig({
  displayName: "SecondaryHero__SubHeading",
  componentId: "sc-6yoig1-4"
})(["font-weight:", ";line-height:", ";font-size:", ";@media (min-width:", "){line-height:", ";font-size:", ";}"], FONT_WEIGHT.LIGHT, LINE_HEIGHT.STANDARD.SMALL, FONT_SIZE.NORMAL, BREAKPOINT.MD, LINE_HEIGHT.STANDARD.LARGE, FONT_SIZE.LARGE);
var LFrameBackground = /*#__PURE__*/styled.div.withConfig({
  displayName: "SecondaryHero__LFrameBackground",
  componentId: "sc-6yoig1-5"
})(["background:url(", ") no-repeat;background-position:center center 15px;background-size:900px;width:100%;height:100%;position:absolute;top:0;left:0;@media (min-width:", "){background-position:50vw 0;}@media (min-width:", "){font-size:48px;line-height:56px;background-size:auto;}"], LSHAME_SECONDARY_BLUE, BREAKPOINT.XS, BREAKPOINT.MD);
export default SecondaryHero;